import { Helmet } from "react-helmet-async";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";

import { Link } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa6";
import { HiOutlineBookOpen } from "react-icons/hi";

const Academia = () => {
  return (
    <section>

      <div className="about-mijsc-section w-full bg-cover h-fit pb-5">
        {/* SEO */}
        <Helmet>
          <title>Academia </title>
          <meta
            name="description"
            content="Contact Mizuho India Japan Study Centre (MIJSC), Indian Institute of Management Bangalore."
          />
        </Helmet>
        <BreadCrumbs />
        <div className="container mx-auto px-4 my-10">
          <h1 className="md:text-4xl text-lg py-3 text-green-600 font-semibold text-left mx-5 mb-10"> Academia </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mx-3">
            <div className="bg-green-100 rounded-3xl">
              <div className="flex items-center justify-center">
                <img
                  src="assets/colleges/hitotsubashi-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-1.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black"> Hitotsubashi University</p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">A GNAM Partner, ICS connects with IIMB to position their students, faculty, staff, alumni and other constituencies so that they can deepen their understanding of differences and commonalities in their economies and increase their effectiveness.</p>
            </div>
            <div className="bg-green-100 rounded-3xl  ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/international-university-of-japan.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-2.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black"> International University of Japan</p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Partnering for the exchange of academic staff and, students. Both institutes agree that research into the problems of the bilateral relationship between India and Japan can be fruitfully advanced by the exchanges of documents, information and occasionally by students who are working on the same set of issues.              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/kyoto-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-3.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    Kyoto University
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                The two parties will promote activities pertaining to the exchange of scientific materials, publications and information. They will also collaborate on exchange of faculty members, students and joint research.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/the-university-of-tokyo.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-4.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    The University of Tokyo
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Partners for exchanging faculty and students. Conducting collaborative research, holding joint lectures and symposia. Collaboration also for exchange of academic information and materials.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/waseda-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-5.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    Waseda University
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Collaborating to promote the exchange of faculty for joint teaching and research; to promote the exchange of qualified masters and doctoral students. To promote collaborative research in areas of mutual interest for publishing in joint authorship.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/meiji-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-6.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    Meiji University
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Facilitating faculty and student exchanges for joint teaching, research, and collaborative projects, with the goal of joint authorship in areas of shared interest.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/nagoya-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-7.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    Nagoya University
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Supporting faculty and student exchanges for joint teaching, research, and collaborative projects, aiming for joint authorship in mutually interesting research areas.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/hiroshima-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-8.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">
                    Hiroshima University
                  </p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Promoting faculty exchanges for joint teaching and research and facilitating the exchange of qualified master's and doctoral students. Encouraging collaborative research in mutual interest areas for joint publication.
              </p>
            </div>
            <div className="bg-green-100 rounded-3xl ">
              <div className="flex items-center justify-center   ">
                <img
                  src="assets/colleges/keio-university.png"
                  alt="Faculty Development Program"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-white rounded-md w-[93%] h-14 mx-3">
                <div className="flex gap-2 h-full items-center justify-center">
                  <img src="assets/colleges/icon-9.png" alt="College icon"  className="w-auto h-full rounded-lg py-2" />
                  <p className="text-black">Keio University</p>
                </div>
              </div>
              <p className="mt-4 text-black text-xs mx-3 mb-3">
                Both institutes are engaged in active students’ exchange for the past several years.
              </p>
            </div>


          </div>
        </div>
      </div>
    </section>
  )
}

export default Academia
